import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";

/** User Management Page Styling */
import "./Clients.scss";
import ClientList from "./components/clientList/ClientList";
import { encryptUrlData } from "../../services/CryptoService";
import { useNavigate } from "react-router-dom";
import useDebounce from "../../app/customHooks/useDebounce";
import Label from "../../components/ui/label/Label";
import SearchBar from "../../components/ui/searchBar/SearchBar";
import DropdownSelect from "../../components/forms/ui/inputs/dropdown/DropdownSelect";
import PropTypes from "prop-types";

/** Lazily Loaded Components */
const AddEditClient = lazy(() =>
  import("./components/addEditClient/AddEditClient")
);

const Clients = (props) => {
  const molGridRef = useRef();
  const navigate = useNavigate();

  const [isEdit, setIsEdit] = useState(false);
  const [editClientData, setEditClientData] = useState(null);
  const [isClientModelOpen, setIsClientModelOpen] = useState(false);
  const [searchText, setsearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 300);
  const [selectedStatus, setSelectedStatus] = useState(  { value: 1, label: "Active" });


  const handleAddClientClick = () => {
    setIsClientModelOpen(true);
    setEditClientData(null);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsClientModelOpen(false);
    setEditClientData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    setEditClientData(data);
    setIsClientModelOpen(true);
  };

  const handleViewClick = (data) => {
    const req = {
      clientName: data.clientName,
      ein: data.ein,
      status: data.status,
      clientID: data.clientID,
    };

    navigate(`/clientDetails/${encryptUrlData(req)}`);
  };

  const handleStatusChange = (selected) => {
    setSelectedStatus(selected);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  const handleSearchChange = (e) => {
    let value = e?.target?.value;
    setsearchText(value);
  };

  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 2, label: "InActive" },
    { value: 0, label: "All" },
  ];
  
  return (
    <>
      <div className="client-list">
        <CardSection cardTitle={"Filter Options"}>
          <div className="row">
            <div className="col-4">
              <Label labelName={"Client Name and EIN"} />
              <SearchBar
                onChange={handleSearchChange}
                placeholder={
                  props.placeholder || "Search by Client Name and EIN"
                }
              />
            </div>
            <div className="col-2 center-check-box mt-auto">
            <Label labelName={"Status"} />
              <DropdownSelect
                optionsValue={statusOptions}
                placeholder={"Select Status"}
                isMultiSelect={false}
                isDropdownDisabled={false}
                handleDropdownChange={handleStatusChange}
                value={selectedStatus}
              />
            </div>
          </div>
        </CardSection>
        <div className="client-list-sec">
          <CardSection
            cardTitle={"Clients"}
            rightButton={true}
            buttonClassName={"blue-btn"}
            titleButtonClick={handleAddClientClick}
            buttonText={"ADD"}
            searchInput={false}
            isButtonVisible={true}
            isButtonLoading={""}
            isIcon={true}
            iconClass="uil:plus"
          >
            <div className="only-list-body-scroll">
              <ClientList
                ref={molGridRef}
                onView={handleViewClick}
                search={debouncedSearch}
                status={selectedStatus}
              />
            </div>
          </CardSection>
        </div>
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update Client` : `Add Client`}
        modalSize={"w-35"}
        isOpen={isClientModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditClient
          isEdit={isEdit}
          isOpen={isClientModelOpen}
          initData={editClientData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>
    </>
  );
};

Clients.propTypes = {
  placeholder: PropTypes.string,
};


export default Clients;
